import axios from 'axios'
import { auditDayRange, DocumentJobDetailRecord, DocumentJobListItem, DocumentJobOutcome, DocumentJobProducer, ShadowJobComparison } from '@numeo/types-core'

export const SHADOW_DIFFERENCES_PAGE_SIZE = 50

export interface ShadowDifferencesList {
    rows: DocumentJobListItem[]
    total: number
    totalPages: number
}

/** The job and a short-lived link to its source document. */
export interface JobDocument {
    job: DocumentJobDetailRecord
    previewUrl: string | null
}

export const shadowDifferencesApi = {
    /** The shadow jobs of one day (the viewer's own) that were compared with the legacy chain and differ in at least one field, newest first. */
    async list(params: { day: string; timeZone: string; projectName?: string; page: number }): Promise<ShadowDifferencesList> {
        const { start, end } = auditDayRange(params.day, params.timeZone)
        const res = await axios.get('/gluon/document-jobs/v1', {
            params: {
                producer: DocumentJobProducer.RATECON_EMAIL_SHADOW,
                outcome: DocumentJobOutcome.SHADOW_MISMATCHED,
                startDate: start.toISOString(),
                endDate: new Date(end.getTime() - 1).toISOString(),
                projectName: params.projectName,
                page: params.page,
                pageSize: SHADOW_DIFFERENCES_PAGE_SIZE,
            },
        })
        return res.data.data as ShadowDifferencesList
    },

    /** One job against the RateConf the legacy chain saved, field by field. */
    async getDelta(jobId: string): Promise<ShadowJobComparison> {
        const res = await axios.get(`/gluon/document-jobs/${jobId}/shadow/v1`)
        return res.data.data as ShadowJobComparison
    },

    async getDocument(jobId: string): Promise<JobDocument> {
        const res = await axios.get(`/gluon/document-jobs/${jobId}/v1`)
        return { job: res.data.data.job, previewUrl: res.data.data.previewUrl }
    },
}
